module.exports = __webpack_public_path__ + "static/img/brisbane.7667224.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brisbane.jpg
// module id = +/F5
// module chunks = 1